import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ShipmentTrackingInfo } from '@stone/interfaces';

interface TrackingState {
  data: Record<number, ShipmentTrackingInfo>;
  loading: boolean;
  error: string | null;
}

const initialState: TrackingState = {
  data: {},
  loading: false,
  error: null,
};

const trackingSlice = createSlice({
  name: 'stone.tracking',
  initialState,
  reducers: {
    fetchTrackingRequest: (state, _action: PayloadAction<number>) => {
      state.loading = true;
      state.error = null;
    },
    fetchTrackingSuccess: (state, action: PayloadAction<{ id: number; data: ShipmentTrackingInfo }>) => {
      state.data[action.payload.id] = action.payload.data;
      state.loading = false;
    },
    fetchTrackingFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchTrackingRequest, fetchTrackingSuccess, fetchTrackingFailure } = trackingSlice.actions;
export default trackingSlice.reducer;
